import qs from 'qs';
import {api} from './api';
import { Product, ProductDocument, ProductListItem } from '../containers/products/types';
import { ProductImageItem } from '../types';

export const productsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		productList: builder.query<ProductListItem[], void>({
			query: () => ({
				url: 'products/list',
				method: 'GET',
			}),
			providesTags: ['Products'],
		}),
		productsFind: builder.mutation({
			query: (findOptions: object) => ({
				url: `products/find?${qs.stringify(findOptions)}`,
				method: 'GET',
			}),
		}),
		productCreate: builder.mutation({
			query: (product: Omit<Product, 'id' | 'images' | 'digitalDelivery' | 'isBundle'>) => ({
				url: 'products',
				method: 'POST',
				body: product,
			}),
			invalidatesTags: ['Products'],
		}),
		productDelete: builder.mutation({
			query: (id: number) => ({
				url: `products/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Products', 'QuickOrderInfo'], // quick order products could get removed
		}),
		productUpdate: builder.mutation({
			query: (product: Partial<Omit<Product, 'id'>> & {id: number}) => ({
				url: `products/${product.id}`,
				method: 'PUT',
				body: product,
			}),
			invalidatesTags: ['Products', 'PlanInfo', 'QuickOrderInfo'], // quick order products could turned into bundle or not
		}),
		productInfo: builder.query<Product, number>({
			query: (id: number) => ({
				url: `products/${id}/info`,
				method: 'GET',
			}),
			providesTags: ['Product'],
		}),
		findWithCustomProperties: builder.query({
			query: (id: number) => ({
				url: `products/${id}/findWithCustomProperties`,
				method: 'GET',
			}),
		}),
		productImageUpload: builder.mutation({
			query: ({id, formData}: {id: number, formData: FormData}) => ({
				url: `products/${id}/uploadImage`,
				method: 'POST',
				body: formData,
			}),
			invalidatesTags: ['Product', 'Products'],
		}),
		productImageDelete: builder.mutation({
			query: (id: number) => ({
				url: `products/images/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Product', 'Products'],
		}),
		productImagesReorder: builder.mutation<Pick<ProductImageItem, 'id' | 'rank'>[], Pick<ProductImageItem, 'id' | 'rank'>[]>({
			query: (reorderedItems) => ({
				url: 'products/reorderImages',
				method: 'PUT',
				body: {
					images: reorderedItems
				},
			}),
			invalidatesTags: ['Product', 'Products'],
		}),
		productDocumentUpload: builder.mutation({
			query: ({id, formData}: {id: number, formData: FormData}) => ({
				url: `products/${id}/uploadDocument`,
				method: 'POST',
				body: formData,
			}),
			invalidatesTags: ['ProductDocuments'],
		}),
		productDocumentList: builder.query<ProductDocument[], number>({
			query: (id: number) => ({
				url: `products/${id}/documents`,
				method: 'GET',
			}),
			providesTags: ['ProductDocuments'],
		}),
		productDocumentDelete: builder.mutation({
			query: (id: number) => ({
				url: `productDocuments/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['ProductDocuments'],
		})
	}),
});

export const {useProductListQuery, useProductsFindMutation, useProductDeleteMutation, useProductUpdateMutation, useProductInfoQuery, useFindWithCustomPropertiesQuery, useProductCreateMutation, useProductImageUploadMutation, useProductImageDeleteMutation, useProductDocumentUploadMutation, useProductDocumentDeleteMutation, useProductDocumentListQuery, useProductImagesReorderMutation} = productsApi;
